import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Editor, Toolbar } from 'ngx-editor';
import { Subject, takeUntil } from 'rxjs';
import { TenantNode } from 'src/app/core/interfaces/tenant/tenant.interface';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { UniversityCommunicationService } from 'src/app/core/services/university-communication/university-communication.service';
import { UsersService } from 'src/app/core/services/users/users.service';
import { getMailReplyFormat } from 'src/app/core/helpers/helperfunc';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { ActivatedRoute } from '@angular/router';
import { maxAttachmentSize } from 'src/app/core/constants/mail-box-const';

@Component({
    selector: 'app-compose-mail-popup',
    templateUrl: './compose-mail-popup.component.html',
    styleUrls: ['./compose-mail-popup.component.scss'],
})
export class ComposeMailPopupComponent implements OnInit, OnDestroy {
    user_details: any;
    compose_email_form: FormGroup;
    from_list:any = [];
    from_mail_list: any = [];
    to_email_list: string[] = [];
    cc_email_list: string[] = [];
    bcc_email_list: string[] = [];
    maxAttachmentSize: number = maxAttachmentSize;

    config: any = {
        placeholder: '',
        tabsize: 2,
        height: '500px',
        // uploadImagePath: '/api/upload',
        shortcuts: false, // Disable keyboard shortcuts
        spellCheck: true, // Enable spellcheck
        disableGrammar: false, // Grammar should be enabled (default behavior)
        toolbar: [
            ['misc', ['codeview', 'undo', 'redo']],
            // ['style', ['bold', 'italic', 'underline', 'clear']],
            [
                'font',
                [
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'superscript',
                    'subscript',
                    'clear',
                ],
            ],
            ['fontsize', ['fontname', 'fontsize', 'color']],
            // ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
            ['para', ['ul', 'ol', 'paragraph']],
            // ['insert', ['table', 'picture', 'link', 'video', 'hr']]
            ['insert', ['picture', 'link']],
        ],
        fontNames: [
            'Helvetica',
            'Arial',
            'Arial Black',
            'Comic Sans MS',
            'Courier New',
            'Roboto',
            'Times',
        ],
    };
    upload_files: any[] = [];
    is_submitted: boolean = false;
    public subTenant: string[] = [];
    public tenant: string[] = [];
    private _unsubscribeAll: Subject<any> = new Subject();
    getMailReplyFormat = getMailReplyFormat;
    reply_hidden_content: any;
    see_original_mail: boolean = false;
    referenceId: any;
    camsId: any;

    constructor(
        public dialogRef: MatDialogRef<ComposeMailPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public email_data: any,
        private _userService: UsersService,
        private _authService: AuthenticationService,
        private _loaderService: LoaderService,
        private _fb: FormBuilder,
        private _toasterService: ToasterService,
        private _universitycommunicationService: UniversityCommunicationService,
        private localStorageService: LocalStorageService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        console.log(this.email_data,'email_data')
        this.user_details = this._authService.getLoginUserDetails();
        this.initiateEmailForm();
        this.getUserMailIds();

        this.route.queryParams.subscribe((params) => {
            this.referenceId = params['mail_id'];
            this.camsId = params['cams_id'];
        });

        if (Object.keys(this.email_data).length) {
            if (this.email_data.type === 'reply') {
                this.to_email_list.push(this.email_data.from_mail);
                if (typeof this.to_email_list[0] === 'string' && this.to_email_list.length === 1 && this.to_email_list[0].includes(',')) {
                    this.to_email_list = this.to_email_list[0].split(',').map(e => e.trim());
                }
                // for reply (its only send "to") thats why i hide cc and bcc

                // if (this.email_data.cc_mail) {
                //     this.cc_email_list.push(this.email_data.cc_mail);
                // }
                // if (typeof this.cc_email_list[0] === 'string' && this.cc_email_list.length === 1 && this.cc_email_list[0].includes(',')) {
                //     this.cc_email_list = this.cc_email_list[0].split(',').map(e => e.trim());
                // }
                // if (this.email_data.bcc_mail) {
                //     const emails = this.email_data.bcc_mail?.split(',').map(email => email.trim()).filter(email => email); // Split and trim
                //     this.bcc_email_list.push(...emails);
                // }
                // if (typeof this.bcc_email_list[0] === 'string' && this.bcc_email_list.length === 1 && this.bcc_email_list[0].includes(',')) {
                //     this.bcc_email_list = this.bcc_email_list[0].split(',').map(e => e.trim());
                // }
                if (this.email_data.subject) {
                    let subject = this.email_data.subject.includes('Re:')
                        ? this.email_data.subject
                        : `Re: ${this.email_data.subject}`;
                    this.compose_email_form.get('subject').patchValue(subject);
                }
                this.reply_hidden_content = this.getMailReplyFormat(
                    {
                        mail_details: {
                            ...this.email_data,
                            assignDate: this.email_data?.createdAt
                        }
                    },
                    null
                );
                if (this.reply_hidden_content) {
                    this.compose_email_form
                        .get('html')
                        .patchValue(this.reply_hidden_content);
                }
            }
            if (this.email_data.type === 'replyAll') {
                if (typeof this.email_data.to_mail === 'string') {
                    const toMails = this.email_data.to_mail.includes(',')
                        ? this.email_data.to_mail.split(',').map(e => e.trim())
                        : [this.email_data.to_mail.trim()];
                    this.to_email_list.push(...toMails);
                }
                // Handle from_mail
                if (typeof this.email_data.from_mail === 'string' && this.email_data.from_mail.trim() !== '') {
                    this.to_email_list.push(this.email_data.from_mail.trim());
                }
                if (this.email_data.cc_mail) {
                    this.cc_email_list.push(this.email_data.cc_mail);
                }
                if (typeof this.cc_email_list[0] === 'string' && this.cc_email_list.length === 1 && this.cc_email_list[0].includes(',')) {
                    this.cc_email_list = this.cc_email_list[0].split(',').map(e => e.trim());
                }
                if (this.email_data.bcc_mail) {
                    const emails = this.email_data.bcc_mail?.split(',').map(email => email.trim()).filter(email => email); // Split and trim
                    this.bcc_email_list.push(...emails);
                }
                if (typeof this.bcc_email_list[0] === 'string' && this.bcc_email_list.length === 1 && this.bcc_email_list[0].includes(',')) {
                    this.bcc_email_list = this.bcc_email_list[0].split(',').map(e => e.trim());
                }
                if (this.email_data.subject) {
                    let subject = this.email_data.subject.includes('Re:')
                        ? this.email_data.subject
                        : `Re: ${this.email_data.subject}`;
                    this.compose_email_form.get('subject').patchValue(subject);
                }
                this.reply_hidden_content = this.getMailReplyFormat(
                    {
                        mail_details: {
                            ...this.email_data,
                            assignDate: this.email_data?.createdAt
                        }
                    },
                    null
                );
                if (this.reply_hidden_content) {
                    this.compose_email_form
                        .get('html')
                        .patchValue(this.reply_hidden_content);
                }
            }
            if (this.email_data.type === 'forward') {
                // this.to_email_list.push(this.email_data.to_mail);
                //  if (typeof this.to_email_list[0] === 'string' && this.to_email_list.length === 1 && this.to_email_list[0].includes(',')) {
                //     this.to_email_list = this.to_email_list[0].split(',').map(e => e.trim());
                // }
                // if (this.email_data.cc_mail) {
                //     this.cc_email_list.push(this.email_data.cc_mail);
                // }
                // if (typeof this.cc_email_list[0] === 'string' && this.cc_email_list.length === 1 && this.cc_email_list[0].includes(',')) {
                //     this.cc_email_list = this.cc_email_list[0].split(',').map(e => e.trim());
                // }
                // if (this.email_data.bcc_mail) {
                //     const emails = this.email_data.bcc_mail?.split(',').map(email => email.trim()).filter(email => email); // Split and trim
                //     this.bcc_email_list.push(...emails);
                // }
                // if (typeof this.bcc_email_list[0] === 'string' && this.bcc_email_list.length === 1 && this.bcc_email_list[0].includes(',')) {
                //     this.bcc_email_list = this.bcc_email_list[0].split(',').map(e => e.trim());
                // }
                if (this.email_data.subject) {
                    this.email_data.subject = this.email_data?.subject.replace(/(?:^|\s)(fwd:|fw:)/gi, '').trim();
                    let subject = this.email_data.subject.includes('Fw:')
                        ? this.email_data.subject
                        : `Fw: ${this.email_data.subject}`;
                    this.compose_email_form.get('subject').patchValue(subject);
                }
                this.reply_hidden_content = this.getMailReplyFormat(
                    {
                        mail_details: {
                            ...this.email_data,
                            assignDate: this.email_data?.createdAt
                        }
                    },
                    null
                );
                if (this.reply_hidden_content) {
                    this.compose_email_form
                        .get('html')
                        .patchValue(this.reply_hidden_content);
                }
            }

            if (this.to_email_list.length) {
                this.compose_email_form
                    .get('to')
                    .setValidators([Validators.email]);
                this.compose_email_form.get('to').updateValueAndValidity();
            }
        }
    }

    close(val?: any) {
        this.dialogRef.close(val);
    }

    initiateEmailForm() {
        this.compose_email_form = this._fb.group({
            from: ['', [Validators.required, Validators.email]],
            to: [
                '',
                Validators.compose([Validators.required, Validators.email]),
            ],
            cc: ['', Validators.email],
            bcc: ['', Validators.email],
            subject: ['', [Validators.required]],
            // html: [getMailReplyFormat(), [Validators.required]],
            html: ['', [Validators.required]],
            attachments: [[]],
            agentStatus: [false],
        });
    }

    getUserMailIds() {
        this._loaderService.showLoader();
        this._userService
            .getUserById(this.user_details.id)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res) => {
                    let user_data = res?.data[0];
                    //if (this.email_data.type !== 'reply') {
                    this.from_mail_list = user_data?.userOtherDetails?.composeEmailId
                        ? String(user_data?.userOtherDetails?.composeEmailId)
                            .split(',')
                            .map(email => email.trim()) // Remove extra spaces
                            .filter(email => email)
                        : [];
                    //}
                    console.log(this.from_mail_list,'this.from_mail_list')
                    this._loaderService.hideLoader();
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    addToEmail(event) {
        if (this.compose_email_form.get('to').invalid) {
            return;
        }
        let to_email = this.compose_email_form.value.to;
        this.to_email_list.push(to_email);
        this.compose_email_form.get('to').reset();
        if (this.to_email_list.length) {
            this.compose_email_form.get('to').setValidators([Validators.email]);
            this.compose_email_form.get('to').updateValueAndValidity();
        }
    }

    removeToEmail(index) {
        this.to_email_list.splice(index, 1);
    }

    addCCEmail(event) {
        if (this.compose_email_form.get('cc').invalid) {
            return;
        }
        let cc_email = this.compose_email_form.value.cc;
        this.cc_email_list.push(cc_email);
        this.compose_email_form.get('cc').reset();
    }

    removeCCEmail(index) {
        this.cc_email_list.splice(index, 1);
    }

    addBCCEmail(event) {
        if (this.compose_email_form.get('bcc').invalid) {
            return;
        }
        let bcc_email = this.compose_email_form.value.bcc;
        this.bcc_email_list.push(bcc_email);
        this.compose_email_form.get('bcc').reset();
    }

    removeBCCEmail(index) {
        this.bcc_email_list.splice(index, 1);
    }

    // selectFiles(event: any): void {
    //     let files = event.target.files;
    //     // this.upload_files = [];
    //     if (files) {
    //         for (let file of files) {
    //             this.upload_files.push(file);
    //         }
    //     }
    // }

    selectFiles(event: any): void {
        const files = event.target.files;
        if (files) {
            // Calculate current total size of existing files in MB
            const existingTotalSize = this.upload_files.reduce((total, file) =>
                total + file.size / (1024 * 1024), 0);

            let newFilesTotalSize = 0;
            const validFiles: File[] = [];

            // First pass: calculate total size of new files
            for (const file of files) {
                const fileSizeInMB = file.size / (1024 * 1024);
                newFilesTotalSize += fileSizeInMB;

                // Check individual file size
                if (fileSizeInMB > this.maxAttachmentSize) {
                    this._toasterService.showWarnig(
                        'File size exceeds',
                        `File ${file.name} exceeds the size limit of ${this.maxAttachmentSize}MB.`
                    );
                    continue;
                }
                validFiles.push(file);
            }

            // Check if total size (existing + new) exceeds 25MB
            if (existingTotalSize + newFilesTotalSize > this.maxAttachmentSize) {
                this._toasterService.showWarnig(
                    'Total size exceeds limit',
                    `Total file size would exceed ${this.maxAttachmentSize}MB limit. Current total: ${existingTotalSize.toFixed(2)}MB, Attempting to add: ${newFilesTotalSize.toFixed(2)}MB`
                );
            } else {
                // Add only valid files if total size is acceptable
                this.upload_files.push(...validFiles);
            }
        }
        // Reset the input value to allow selecting the same file again
        event.target.value = '';
    }

    removeDoc(index: number) {
        this.upload_files.splice(index, 1);
    }

    public getSelectedDropdown(event: TenantNode[]): void {
        this.subTenant = [];
        this.tenant = [];
        event.map((item) => {
            if (item.label === 'tenant') {
                this.tenant.push(item.value);
            } else if (item.label === 'sub-tenant') {
                this.subTenant.push(item.value);
            }
        });
    }

    getPayload() {
        let to_mail = '';
        if (this.to_email_list.length && this.compose_email_form.value.to) {
            to_mail = this.to_email_list
                .toString()
                .concat(`,${this.compose_email_form.value.to}`);
        } else if (
            !this.to_email_list.length &&
            this.compose_email_form.value.to
        ) {
            to_mail = this.compose_email_form.value.to;
        } else if (
            this.to_email_list.length &&
            !this.compose_email_form.value.to
        ) {
            to_mail = this.to_email_list.toString();
        }

        let cc_mail = '';
        if (this.cc_email_list.length && this.compose_email_form.value.cc) {
            cc_mail = this.cc_email_list
                .toString()
                .concat(`,${this.compose_email_form.value.cc}`);
        } else if (
            !this.cc_email_list.length &&
            this.compose_email_form.value.cc
        ) {
            cc_mail = this.compose_email_form.value.cc;
        } else if (
            this.cc_email_list.length &&
            !this.compose_email_form.value.cc
        ) {
            cc_mail = this.cc_email_list.toString();
        }

        let bcc_mail = '';
        if (this.bcc_email_list.length && this.compose_email_form.value.bcc) {
            bcc_mail = this.bcc_email_list
                .toString()
                .concat(`,${this.compose_email_form.value.bcc}`);
        } else if (
            !this.bcc_email_list.length &&
            this.compose_email_form.value.bcc
        ) {
            bcc_mail = this.compose_email_form.value.bcc;
        } else if (
            this.bcc_email_list.length &&
            !this.compose_email_form.value.bcc
        ) {
            bcc_mail = this.bcc_email_list.toString();
        }

        if (to_mail && this.compose_email_form.get('to').valid) {
            this.compose_email_form.get('to').clearValidators();
            this.compose_email_form.get('to').updateValueAndValidity();
        }

        if (cc_mail) {
            this.compose_email_form.get('cc').clearValidators();
            this.compose_email_form.get('cc').updateValueAndValidity();
        }

        if (bcc_mail) {
            this.compose_email_form.get('bcc').clearValidators();
            this.compose_email_form.get('bcc').updateValueAndValidity();
        }

        let html = this.email_data?.message_id
            ? `${this.compose_email_form.value.html}<br/>${this.reply_hidden_content}`
            : this.compose_email_form.value.html;
        let formData = new FormData();
        formData.append('to', to_mail);
        formData.append('cc', cc_mail);
        formData.append('bcc', bcc_mail);
        formData.append('html', html);
        formData.append('subject', this.compose_email_form.value.subject);
        formData.append('applicationId', this.camsId);
        formData.append('referenceId', this.referenceId);
        formData.append('showAgent', String(this.compose_email_form.value.agentStatus));

        this.upload_files.forEach((element) => {
            formData.append('attachments', element);
        });

        return formData;
    }

    sendMail() {
        this.is_submitted = true;

        let params = '?';
        if (this.compose_email_form.value.from) {
            params += `from=${this.compose_email_form.value.from}`;
        }
        if (this.subTenant?.length) {
            params += `&group=true&`;
            params += `userIds=${this.subTenant.toString()}`;
        }
        params += `&referenceId=${this.referenceId}&applicationId=${this.camsId}`
        let formData = this.getPayload();

        if (this.compose_email_form.invalid) {
            return;
        }

        this._loaderService.showLoader();
        this._universitycommunicationService
            .sendMail(params, formData)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res) => {
                    this._loaderService.hideLoader();
                    if (res?.data?.status) {
                        this.close(true);
                        this._toasterService.showSuccess(
                            'SUCCESS',
                            'Email sent successfully'
                        );
                    } else {
                        this._toasterService.showError('ERROR!', res?.data?.message);
                    }
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    discard() {
        this.compose_email_form.reset();
        this.upload_files = [];
        this.to_email_list = [];
        this.cc_email_list = [];
        this.bcc_email_list = [];
    }

    seeOriginalMail() {
        this.see_original_mail = !this.see_original_mail;
    }

    contentChanged(event: string) {
        this.compose_email_form.get('html').setValue(event);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
